import React from 'react';

import type { IntakeStatusNote } from '@shared/patient-intake-status';

import { usePatientIntakeStatusContext } from '../hooks';
import { Note } from './Note.tsx';
import { NoteDisplayWithoutContext } from './NoteDisplayWithoutContext.tsx';

interface NoteDisplayProps extends Omit<React.ComponentProps<typeof Note>, 'children' | 'visibility'> {
  stepId: string | null;
  noteConfig: Pick<IntakeStatusNote, 'id' | 'visibility'> | null;
  prefix?: string;
}

export const NoteDisplay: React.FC<NoteDisplayProps> = ({ stepId, noteConfig, prefix, ...props }) => {
  const { isHealthcareProvider, patientId } = usePatientIntakeStatusContext();

  return (
    <NoteDisplayWithoutContext
      stepId={stepId}
      noteConfig={noteConfig}
      isHealthcareProvider={isHealthcareProvider}
      patientId={patientId}
      {...props}
    />
  );
};
